<template>
  <div>
    <header-title
      title="معلومات التواصل"
      titlePrevious="المنظمة"
      color="#ea5455"
    />

    <!--Sub Header End-->
    <!--Main Content Start-->
    <div class="main-content">
      <div class="contact-details p80 pagebg2">
        <div v-if="loading" class="loading_skeleton container">
          <div class="row">
            <div class="col-12">
              <b-skeleton height="150px"></b-skeleton>
            </div>
            <div v-for="n in 3" :key="n" class="col-md-4 col-sm-6 px-2 mt-5">
              <b-skeleton height="150px"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="mb-2 line-height-2">
            <h5 class="titel_branch">معلومات التواصل الرئيسية</h5>
            <hr />
            <ul>
              <li v-for="(contact, i) in dataContactUs.ngo.contacts" :key="i">
                <img
                  v-if="contact.type"
                  :src="
                    require(`@/assets/contacts/ngo_${contact.type.icon}.png`)
                  "
                  width="18"
                  height="18"
                  class="mr-1"
                />
                <strong v-if="contact.type">{{ contact.type.name_ar }}:</strong>
                {{ contact.value }}
              </li>
            </ul>
          </div>
          <br />
          <div class="row">
            <div
              v-for="(item, index) in dataContactUs.branches"
              :key="index"
              class="col-md-3 col-sm-6"
              style="margin-bottom: 25px"
            >
              <div class="add-box">
                <h5 class="titel_branch">
                  {{ item.info.name_ar }}
                </h5>
                <ul>
                  <li v-for="contact in item.contacts" :key="contact.id">
                    <img
                      v-if="contact.type"
                      :src="
                        require(`@/assets/contacts/ngo_${contact.type.icon}.png`)
                      "
                      width="18"
                      height="18"
                      class="mr-1"
                    />
                    <strong v-if="contact.type"
                      >{{ contact.type.name_ar }}:</strong
                    >
                    <a
                      :href="contact.value"
                      target="_blank"
                      v-if="contact.type.name_ar === 'فيسبوك'"
                    >
                      صفحة المنظمة
                    </a>
                    <span v-else>{{ contact.value }}</span>
                  </li>
                  <li>
                    <feather-icon icon="MapPinIcon" class="mr-1" />
                    <strong>العنوان:</strong>
                    {{ item.info.address }}
                  </li>
                </ul>
              </div>
            </div>
            <alert
              massage="عذراً لا يوجد معلومات التواصل للفروع "
              class="w-100 mx-1"
              v-if="dataContactUs.branches.length == 0"
            ></alert>
          </div>
        </div>
      </div>
      <!--Contact Us Start-->
      <!-- Google Map with Contact Form -->
      <div class="map-form p80">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-6">
              <h3 class="stitle">
                تواصل معنا ({{
                  dataContactUs.ngo ? dataContactUs.ngo.info.name_ar : ""
                }})
              </h3>
              <div class="contact-form">
                <validation-observer ref="contactUsValidation">
                  <b-form class="auth-login-form mt-2" @submit.prevent>
                    <div class="row">
                      <div class="col-md-6 col-sm-6">
                        <form-input
                          label="الاسم الكامل*"
                          rules="required"
                          v-model="fullName"
                        />
                      </div>
                      <div class="col-md-6 col-sm-6">
                        <form-cleave
                          isNumber
                          :charsCount="10"
                          label="رقم الموبايل*"
                          rules="required|min:10"
                          v-model="phone"
                        />
                      </div>
                      <div class="col-md-6 col-sm-6">
                        <form-select
                          label="المحافظة*"
                          v-model="selectedGov"
                          :getOptionLabel="(x) => x.name_ar"
                          :reduce="(x) => x.id"
                          id="sgovernorate"
                          ep="v2/guest/selects/governorates"
                          rules="required"
                        />
                      </div>
                      <div class="col-md-6 col-sm-6">
                        <form-input
                          label="البريد الالكتروني "
                          v-model="email"
                        />
                      </div>

                      <div class="col-md-6 col-sm-6">
                        <form-input
                          label="الموضوع*"
                          rules="required"
                          v-model="subject"
                        />
                      </div>

                      <div class="col-md-6 col-sm-6">
                        <b-form-group class="mb-2" label="الرسالة*">
                          <validation-provider
                            #default="{ errors }"
                            name="نص الرسالة"
                            rules="required"
                            mode="passive"
                          >
                            <b-form-textarea
                              placeholder="اكتب رسالتك"
                              v-model="content"
                              :state="errors.length > 0 ? false : null"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </div>
                    </div>
                    <b-button
                      block
                      variant="primary"
                      type="submit"
                      value="Send Message"
                      v-b-modal.modal-danger
                      @click="validationForm"
                      :disabled="loadingSubmit"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <b-spinner
                        v-if="loadingSubmit"
                        style="width: 1.5rem; height: 1.5rem"
                        variant="light"
                        class="mx-2"
                      />
                      إرسال رسالة
                    </b-button>
                  </b-form>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Google Map with Contact Form End -->
    </div>
    <!--Main Content End-->
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import NgoHeader from "../../components/NgoHeader.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import HeaderTitle from "../../components/HeaderTitle.vue";
import FormSelect from "@/components/form-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import FormInput from "@/components/form-input";
import FormCleave from "@/components/FormCleave.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BTable,
  BButton,
  BFormInput,
  BFormTextarea,
  BNav,
  BNavItem,
  BModal,
  VBModal,
  BSpinner,
  BFormGroup,
  BForm,
  BSkeleton,
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BNav,
    BNavItem,
    NgoHeader,
    Ripple,
    vSelect,
    BModal,
    VBModal,
    BSpinner,
    HeaderTitle,
    FormSelect,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BSkeleton,
    Alert,
    FormInput,
    FormCleave,
    ToastificationContent,
  },
  mixins: [togglePasswordVisibility],
  props: ["id"],
  data() {
    return {
      currentPage: 1,
      selectedGov: "",
      fullName: "",
      email: "",
      phone: "",
      subject: "",
      content: "",
      required,
    };
  },

  directives: {
    "b-modal": VBModal,
    Ripple,
  },

  methods: {
    emptyForm() {
      this.fullName = "";
      this.email = "";
      this.phone = "";
      this.subject = "";
      this.selectedGov = "";
      this.content = "";
      this.$route.params.id = "";
    },
    validationForm() {
      this.$refs.contactUsValidation.validate().then(async (success) => {
        if (success) {
          await this.submitContact();
        }
      });
    },

    async submitContact() {
      await this.$store
        .dispatch("NgoHome/contact_us/submitContactUs", {
          submitPayload: {
            full_name: this.fullName,
            email: this.email,
            phone: this.phone,
            subject: this.subject,
            governorate_id: this.selectedGov,
            content: this.content,
            ngo_id: parseInt(this.id),
          },
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم إرسال رسالتك  بنجاح ",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
          this.emptyForm();
        });
    },
  },
  computed: {
    ...mapGetters("NgoHome/contact_us", [
      "loading",
      "governorates",
      "dataContactUs",
      "erorrSubmit",
      "loadingSubmit",
    ]),
  },

  created() {
    this.$store.dispatch("NgoHome/contact_us/getDataContactUs", {
      id: this.id,
    });
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";

.main-content {
  .contact-details {
    .loading_skeleton {
      min-height: 300px;
    }
  }
  .h3-logo-row .h3-logo {
    padding: 2px !important;
  }

  .label_form {
    margin: 5px;
  }
  .add-box {
    min-height: 300px !important;
  }

  @media (max-width: 1030px) {
    .titel_contact.stitle {
      font-size: 20px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .add-box {
      .titel_branch {
        font-size: 15px;
      }
    }
  }
}
</style>
